export const SnackbarContent = theme => ({
  styleOverrides: {
    root: {
      color: 'white',
      borderRadius: 12,
      backgroundColor: theme.palette.primary.main
    }
  }
});